import React, { useState } from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import { StyledRoleTable } from "./Role.style";

const RoleTable = ({ roles, access, openRoleDialog, setSelectedRole }) => {
  const [page, setPage] = useState(1);
  const numPerPage = 10;
  const totalCount = roles ? roles.length : 0;

  const startIndex = page === 1 ? 0 : (page - 1) * numPerPage;

  return (
    <StyledRoleTable>
      {(!roles || roles.length === 0) && (
        <div className="table-empty">No roles found.</div>
      )}

      {roles && roles.length > 0 && (
        <div className="table-shell">
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="role table">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell sx={{ minWidth: 170, textAlign: "right" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {roles.slice(startIndex, startIndex + numPerPage).map((row) => (
                  <TableRow
                    key={`role-item-${row.id}`}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.id}
                    </TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.description || "-"}</TableCell>
                    <TableCell sx={{ textAlign: "right" }}>
                      <div className="row-actions">
                        {access.getDetailByIdRoleAccess && (
                          <Button
                            onClick={() => {
                              setSelectedRole(row);
                            }}
                            variant="outlined"
                            size="small"
                          >
                            Permission
                          </Button>
                        )}
                        {access.editRoleAccess && (
                          <Button
                            onClick={() => {
                              openRoleDialog(row);
                            }}
                            variant="outlined"
                            size="small"
                          >
                            Edit
                          </Button>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}

                {Math.ceil(totalCount / numPerPage) > 1 && (
                  <TableRow key={"pg"}>
                    <TableCell colSpan={7}>
                      <div className="pagination-section">
                        <Pagination
                          count={Math.ceil(totalCount / numPerPage)}
                          page={page}
                          onChange={(event, value) => {
                            setPage(value);
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </StyledRoleTable>
  );
};

export default RoleTable;
